"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestSwapper = void 0;
const types_1 = require("@shapeshiftoss/types");
/**
 * Playground for testing different scenarios of multiple swappers in the manager.
 * Meant for local testing only
 */
class TestSwapper {
    constructor() {
        this.supportAssets = [
            'bip122:000000000933ea01ad0ee984209779ba/slip44:0',
            'cosmos:cosmoshub-4/slip44:118',
            'eip155:1/erc20:0xc770eefad204b5180df6a14ee197d99d808ee52d'
        ];
    }
    getType() {
        return types_1.SwapperType.Test;
    }
    getUsdRate(input) {
        console.info(input);
        throw new Error('TestSwapper: getUsdRate unimplemented');
    }
    getMinMax(input) {
        console.info(input);
        throw new Error('TestSwapper: getMinMax unimplemented');
    }
    async approvalNeeded() {
        throw new Error('TestSwapper: approvalNeeded unimplemented');
    }
    async approveInfinite() {
        throw new Error('TestSwapper: approveInfinite unimplemented');
    }
    filterBuyAssetsBySellAssetId(args) {
        const { sellAssetId } = args;
        if (!this.supportAssets.includes(sellAssetId))
            return [];
        return this.supportAssets;
    }
    filterAssetIdsBySellable() {
        return this.supportAssets;
    }
    async buildTrade() {
        throw new Error('TestSwapper: buildTrade unimplemented');
    }
    async getTradeQuote() {
        throw new Error('TestSwapper: getTradeQuote unimplemented');
    }
    async executeTrade() {
        throw new Error('TestSwapper: executeTrade unimplemented');
    }
}
exports.TestSwapper = TestSwapper;
